module.exports = __webpack_public_path__ + "static/media/arkreen_2.a139e7b0.png";